import React from 'react';

import { Typography } from '@mui/material';

import { numberWithCommas, sum } from '@clearverify/utils';

import { OverviewTotalVerifications } from 'src/types/dashboard';

import { DashboardOverviewBlockListItem } from './DashboardOverviewBlockListItem';

type DashboardOverviewBlockTotalVerificationsProps = {
  totalVerifications: OverviewTotalVerifications;
  loading: boolean;
};

export const DashboardOverviewBlockTotalVerifications: React.FC<
  DashboardOverviewBlockTotalVerificationsProps
> = ({ totalVerifications, loading }) => {
  const totalAmount = sum(totalVerifications.auto, totalVerifications.manual);

  return (
    <DashboardOverviewBlockListItem
      loading={loading}
      number={numberWithCommas(totalAmount)}
      title="Total Verifications"
      subtitle={
        <React.Fragment>
          <Typography
            component="span"
            variant="body2"
            color="success.main"
          >{`${numberWithCommas(totalVerifications.auto)} Auto`}</Typography>
          &nbsp;and&nbsp;
          {numberWithCommas(totalVerifications.manual)} Manual
        </React.Fragment>
      }
    />
  );
};
